@if(showActionUser){

  @if (!isAdminContext) {
    <!-- Google-style dropdown menu -->
    <div class="google-menu" @fadeScale>

      <!-- Header: email + close button -->
      <div class="gm-header">
        <span class="gm-email">{{ userLoginResponse.email || userLoginResponse.nomeUsuario }}</span>
        <button class="gm-close-btn" (click)="closeMobile()" aria-label="Fechar">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <!-- Profile: avatar + greeting + manage button -->
      <div class="gm-profile">
        <div class="gm-avatar">{{ userInitials }}</div>
        <div class="gm-greeting">
          Olá, <span class="gm-greeting-name">{{ firstName }}!</span>
        </div>
        <button class="gm-manage-btn" (click)="navigateTo('config/meus-dados')">
          Gerenciar meus dados
        </button>
      </div>

      <hr class="gm-divider" />

      <!-- Enterprise selector -->
      <div class="gm-enterprise-body">
        <form class="form" [formGroup]="model">
          @if (!isLoading) {
            <one-select label="Trocar empresa" controlName="enterpriseSelect" [options]="empresaOptions" />
          }
        </form>
        @if (isLoading) {
          <div class="gm-spinner-wrapper">
            <mat-spinner [diameter]="28"></mat-spinner>
          </div>
        }
      </div>

      <hr class="gm-divider" />

      <!-- Action items -->
      <div class="gm-actions">
        <button class="gm-action-item" (click)="navigateTo('config/minha-empresa')">
          <span class="material-symbols-outlined">domain</span>
          <span>Minha empresa</span>
        </button>
        <button class="gm-action-item" (click)="navigateTo('config/usuarios')">
          <span class="material-symbols-outlined">group</span>
          <span>Usuários</span>
        </button>
        <button class="gm-action-item" (click)="toggleTheme()">
          <span class="material-symbols-outlined">{{ currentTheme === 'light' ? 'dark_mode' : 'light_mode' }}</span>
          <span>Ativar modo {{ currentTheme === 'light' ? 'escuro' : 'claro' }}</span>
        </button>
      </div>

      <hr class="gm-divider" />

      <!-- Footer: logout -->
      <div class="gm-footer">
        <button class="gm-logout-btn" (click)="clickLogout()">
          <span class="material-symbols-outlined">logout</span>
          Sair
        </button>
      </div>

    </div>
  }

  @if (isAdminContext) {
    <div class="google-menu" @fadeScale>

      <!-- Header: email + close button -->
      <div class="gm-header">
        <span class="gm-email">{{ userLoginResponse.email || userLoginResponse.nomeUsuario }}</span>
        @if (noLogado) {
          <one-badge size="sm" [variant]="varianteTipo(noLogado.idTipoDistribuidor)" [icon]="iconeTipo(noLogado.idTipoDistribuidor) || (noLogado.isGod ? 'workspace_premium' : '')">
            {{ noLogado.nomeDistribuidor }} · {{ labelTipo(noLogado.idTipoDistribuidor) }}
          </one-badge>
        }
        <button class="gm-close-btn" (click)="closeMobile()" aria-label="Fechar">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <!-- Profile: avatar + greeting + manage button -->
      <div class="gm-profile">
        <div class="gm-avatar">{{ userInitials }}</div>
        <div class="gm-greeting">
          Olá, <span class="gm-greeting-name">{{ firstName }}!</span>
        </div>
        <button class="gm-manage-btn" (click)="redirectDataConfig()">
          Gerenciar meus dados
        </button>
      </div>

      <hr class="gm-divider" />

      <!-- Distributor selector -->
      <div class="gm-enterprise-body">
        <form class="form" [formGroup]="model">
          @if (!isLoading) {
            <one-select label="Trocar distribuidor" controlName="enterpriseSelect" [options]="distribuidorOptions" />
          }
        </form>
        @if (isLoading) {
          <div class="gm-spinner-wrapper">
            <mat-spinner [diameter]="28"></mat-spinner>
          </div>
        }
      </div>

      <hr class="gm-divider" />

      <!-- Action items -->
      <div class="gm-actions">
        <button class="gm-action-item" (click)="navigateTo('configs/usuarios-admin')">
          <span class="material-symbols-outlined">group</span>
          <span>Usuários Admin</span>
        </button>
        <button class="gm-action-item" (click)="toggleTheme()">
          <span class="material-symbols-outlined">{{ currentTheme === 'light' ? 'dark_mode' : 'light_mode' }}</span>
          <span>Ativar modo {{ currentTheme === 'light' ? 'escuro' : 'claro' }}</span>
        </button>
      </div>

      <hr class="gm-divider" />

      <!-- Footer: logout -->
      <div class="gm-footer">
        <button class="gm-logout-btn" (click)="clickLogout()">
          <span class="material-symbols-outlined">logout</span>
          Sair
        </button>
      </div>

    </div>
  }

  <div class="container-out" (click)="clickContainerOut()"></div>
}